import {
  PostAPI,
  PostAPIWithoutRequest,
  PostAPIWithoutRequestAndKeyData,
} from "src/components/api/helper/apiHelper";

export const Insert = async (request: string) => {
  return PostAPI(request, "WishListMaster/Insert");
};

export const Select = async () => {
  return PostAPIWithoutRequest("WishListMaster/Select");
};

export const Delete = async (request: string) => {
  return PostAPI(request, "WishListMaster/Delete");
};

export const Update = async (request: string) => {
  return PostAPI(request, "WishListMaster/Update");
};

export const SelectByID = async (request: string) => {
  return PostAPI(request, "WishListMaster/SelectByID");
};

export const ShowWishList = async (request: string) => {
  return PostAPI(request, "WishListMaster/ShowWishList");
};

  export const DeleteMultipleWishList = async (request: string) => {
    return PostAPI(request, "WishListMaster/DeleteMultipleWishList");
  };